import pub from './pub';
import log from './log';
import login from './login';
import fuploader from './fuploader';
import none from './none';

export default { pub, none, fuploader, log, login };
